import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CompanyDocument } from '../types';

export const useUpdateCompanyDocument = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<
    { data: CompanyDocument },
    Error,
    { id: string; values: { isArchived: boolean } }
  >({
    mutationFn: ({ id, values }) => api.put<CompanyDocument>(`company-documents/${id}`, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-documents'] });
    },
  });

  const updateCompanyDocument = async (id: string, values: { isArchived: boolean }) => {
    return mutateAsync({ id, values });
  };

  return {
    updateCompanyDocument,
    isLoading,
  };
};
